'use strict';
// Interactive hotspots: clicking a dot toggles its popup; one open at a time.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.block.accessory-discovery [data-hotspot]').forEach((root) => {
        const spots = Array.from(root.querySelectorAll('[data-spot]'));
        const closeAll = (except) => {
            spots.forEach((spot) => {
                var _a, _b;
                if (spot === except) {
                    return;
                }
                spot.classList.remove('is-open');
                (_a = spot.querySelector('[data-spot-toggle]')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'false');
                (_b = spot.querySelector('[data-spot-popup]')) === null || _b === void 0 ? void 0 : _b.setAttribute('hidden', '');
            });
        };
        spots.forEach((spot) => {
            const toggle = spot.querySelector('[data-spot-toggle]');
            const popup = spot.querySelector('[data-spot-popup]');
            if (!toggle || !popup) {
                return;
            }
            toggle.addEventListener('click', (event) => {
                event.stopPropagation();
                const isOpen = spot.classList.contains('is-open');
                closeAll();
                if (!isOpen) {
                    spot.classList.add('is-open');
                    toggle.setAttribute('aria-expanded', 'true');
                    popup.removeAttribute('hidden');
                }
            });
        });
        document.addEventListener('click', (event) => {
            if (!root.contains(event.target)) {
                closeAll();
            }
        });
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeAll();
            }
        });
    });
});
